import { Check } from "lucide-react";
import { SEIT_TEXT, gross } from "@/config/webseiteFakten";
import praxisImg from "@/assets/musik-kita/kinder-instrumente.jpg";

const benefits = [
  "Praxiserprobte Konzepte",
  "Flexibles Lernen – jederzeit und überall",
  "KI-gestützte Unterstützung durch Miko",
  "Regelmäßige Updates und neue Inhalte",
  "Persönlicher Support und Community-Austausch",
  "Zertifikate und Teilnahmebescheinigungen",
];

const WhySection = () => {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-hero-gradient-start via-background to-hero-gradient-end opacity-60" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center max-w-7xl mx-auto">
          
          {/* Left Side - Image */}
          <div className="relative animate-fade-in order-2 lg:order-1 group/image">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl transform transition-all duration-700 hover:scale-[1.02] hover:shadow-[0_20px_60px_-15px_rgba(var(--primary),0.3)]">
              <img 
                src={praxisImg} 
                alt="Kinder musizieren mit verschiedenen Instrumenten" 
                className="w-full h-full object-cover transform transition-transform duration-700 group-hover/image:scale-105"
              />
              {/* Overlay Gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent" />
              
              {/* Animated Ring */}
              <div className="absolute inset-0 rounded-3xl border-2 border-primary/0 group-hover/image:border-primary/50 transition-all duration-700 animate-pulse" />
            </div>
            
            {/* Decorative Element - Animated */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-primary to-accent rounded-3xl opacity-20 blur-2xl -z-10 animate-[pulse_3s_ease-in-out_infinite]" />
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-gradient-to-br from-accent to-primary rounded-full opacity-20 blur-3xl -z-10 animate-[pulse_4s_ease-in-out_infinite]" style={{ animationDelay: '1s' }} />
            
            {/* Floating Badge */}
            <div className="absolute -top-4 -right-4 bg-gradient-to-br from-primary to-accent text-white px-4 py-2 rounded-full shadow-xl font-bold text-sm animate-[bounce_3s_ease-in-out_infinite] backdrop-blur-sm">
              ✨ Praxisnah
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="space-y-8 animate-fade-in order-1 lg:order-2" style={{ animationDelay: "0.1s" }}>
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                Warum{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-accent to-primary bg-[length:200%_auto] animate-gradient">
                  MusiKonzept
                </span>
                ?
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
                Wir machen musikalische Bildung zugänglich, innovativ und praxisnah. 
                {gross(SEIT_TEXT)} unterstützen wir pädagogische Fachkräfte dabei, 
                Musik in ihren Alltag zu integrieren – mit Herz, Expertise und modernster Technologie.
              </p>
            </div>

            {/* Benefits List */}
            <div className="space-y-4">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 group animate-fade-in"
                  style={{ animationDelay: `${0.2 + index * 0.05}s` }}
                >
                  <div className="w-6 h-6 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center flex-shrink-0 mt-1 group-hover:scale-110 transition-transform duration-300">
                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                  </div>
                  <span className="text-base md:text-lg text-foreground group-hover:text-primary transition-colors duration-300">
                    {benefit}
                  </span>
                </div>
              ))}
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default WhySection;
